// extracted by mini-css-extract-plugin
export var body = "index-module--body--JM8dm";
export var footer = "index-module--footer--8bH8s";
export var list = "index-module--list--aVVA5";
export var icon = "index-module--icon--otHWp";
export var ctaTitle = "index-module--ctaTitle--RRLeQ";
export var cta = "index-module--cta--Yi6O8";
export var secondaryCta = "index-module--secondaryCta--FPEZL";
export var button = "index-module--button--Kx3RA";